export default class appLoader {
    constructor(container) {
        this.$container = document.querySelector(container);
        this.initLoadEvents()
    }

    initLoadEvents() {
        if(this.$container.classList.contains('page')) {
            const ld = localStorage.getItem("loaded");
            if(ld !== 'yes') {
                this.$container.classList.add('active');
                window.addEventListener("load", () => {
                    setTimeout(() => {
                        this.$container.classList.remove('active');
                        localStorage.setItem("loaded", "yes");
                    }, 1500)
                });
            }
        }
    }
}

